/**
 * Mobile Menu
 */
const MobileMenu = () => {
  // eslint-disable-next-line global-require
  const focusTrap = require("focus-trap");
  const navToggle = document.querySelector(".header-mobile-menu-toggle");
  const nav = document.querySelector(".nav--main-mobile");
  const navTrap = focusTrap.createFocusTrap(nav, {
    allowOutsideClick: true,
    onDeactivate: () => {
      // eslint-disable-next-line no-use-before-define
      closeNav();
    }
  });
  const overlay = document.querySelector(".mobile-nav-overlay");
  const heroOverlay = document.querySelector(".hero-image-overlay");
  const navClose = document.querySelectorAll(
    ".header-mobile-menu-toggle--close"
  );
  const childToggle = document.querySelectorAll(
    ".mobile-nav-item-children-toggle"
  );
  const childBackToggle = document.querySelectorAll(".mobile-nav-item-back");
  const accordionBtn = document.querySelectorAll(".toggle-accordion");
  const accordionButtons = [].slice.call(accordionBtn);
  const body = document.querySelector("body");
  const childNavs = document.querySelectorAll(".mobile-nav-item--children");
  const childMenuTraps = {};
  /**
   * Setup focus trap for all child nav sections.
   * These will be activated when the relevant child menu is opened and deactivated on close
   */
  const setupChildFocusTraps = () => {
    // Main mobile menu
    childNavs.forEach(childMenu => {
      childMenuTraps[childMenu.id] = focusTrap.createFocusTrap(childMenu, {
        allowOutsideClick: true,
        onDeactivate: () => {
          // eslint-disable-next-line prefer-destructuring
          const activeElement = document.activeElement;
          const navElement = activeElement.closest(
            ".mobile-nav-item--children"
          );

          if (navElement) {
            navElement.classList.remove("open");
          }
        }
      });
    });
  };
  /**
   * Toggle Main nav
   */
  const toggleNav = () => {
    nav.classList.toggle("open");
    nav.removeAttribute("inert");
    overlay.classList.add("overlay-active");
    if (heroOverlay) {
      heroOverlay.classList.add("overlay-active");
      heroOverlay.classList.add("overlay-index");
    }
    body.classList.add("nav-active");

    accordionButtons.forEach(e => {
      e.classList.add("accordion-overlay");
    });

    setTimeout(() => {
      navTrap.activate();
    }, 300);
  };

  /*
   * Close all child navs
   */
  const closeAllNavs = () => {
    const openNavs = nav.querySelectorAll(".open");

    openNavs.forEach(el => {
      el.classList.remove("open");

      if (childMenuTraps[el.id].active) {
        setTimeout(() => {
          childMenuTraps[el.id].deactivate();
        }, 300);
      }
    });
  };

  /**
   * Open child nav
   * @param DOMNode el
   */
  const openNav = el => {
    const childNav = el.parentNode.querySelector(".mobile-nav-item--children");
    childNav.classList.add("open");
    el.setAttribute("aria-expanded", "true");

    setTimeout(() => {
      childMenuTraps[childNav.id].activate();
    }, 300);
  };

  /**
   * Close the main nav
   */
  const closeNav = () => {
    nav.classList.remove("open");
    nav.setAttribute("inert", "");
    overlay.classList.remove("overlay-active");
    if (heroOverlay) {
      heroOverlay.classList.remove("overlay-active");
    }
    body.classList.remove("nav-active");

    setTimeout(() => {
      if (heroOverlay) {
        heroOverlay.classList.remove("overlay-index");
      }

      accordionButtons.forEach(e => {
        e.classList.remove("accordion-overlay");
      });
      navTrap.deactivate();
    }, 300);

    closeAllNavs();
  };

  /**
   * Close current child nav and go back up one level
   * @param DOMNode el
   */
  const goBack = el => {
    const childNavItem = el.parentNode.parentNode;
    childNavItem.classList.remove("open");

    setTimeout(() => {
      childMenuTraps[childNavItem.id].deactivate();
    }, 300);
  };

  /**
   * Bind event handlers
   */
  const bindEventHandlers = () => {
    navToggle.addEventListener("click", () => {
      toggleNav();
    });

    const closeContainer = [].slice.call(navClose);

    closeContainer.forEach(el => {
      el.addEventListener("click", closeNav);
    });

    if (overlay) {
      overlay.addEventListener("click", () => {
        closeNav();
      });
    }

    if (heroOverlay) {
      heroOverlay.addEventListener("click", () => {
        closeNav();
      });
    }

    const toggleContainer = [].slice.call(childToggle);

    toggleContainer.forEach(el => {
      el.addEventListener("click", () => openNav(el));
    });

    const backContainer = [].slice.call(childBackToggle);

    backContainer.forEach(el => {
      el.addEventListener("click", () => goBack(el));
    });
  };

  bindEventHandlers();
  setupChildFocusTraps();
};

export default MobileMenu;
